import { FC } from "react";
import { Flex } from "@smile2impress/components/relaunch";
import { Icon, Icons, Text } from "@smile2impress/components";

import { ListItemProps } from "./ListItem.types";

export const ListItem: FC<ListItemProps> = ({ text, icon }) => {
    const iconComponent =
        typeof icon === "string" ? Icons[icon as keyof typeof Icons] : icon;

    return (
        <Flex
            direction={["row-reverse", "row-reverse", "column"]}
            gap={[4, 4, 1]}
        >
            {iconComponent && (
                <Flex>
                    <Icon
                        w={3}
                        h={3}
                        as={iconComponent}
                        color="base.bitterSweet"
                    />
                </Flex>
            )}
            <Text
                textStyle={["body", "body", "body"]}
                color={["text.base", "text.base", "text.base"]}
                mb={0}
                dangerouslySetInnerHTML={{ __html: text }}
                whiteSpace="pre-wrap"
            />
        </Flex>
    );
};
